const GatewayMutations = {
    setGatewayBindings(state, bindings) {
        if (!bindings) {
            state.gatewayBindings = [];
            return;
        }

        state.gatewayBindings = bindings.map(binding => ({
            staticBinding: {
                id: binding.static_binding.id,
                code: binding.static_binding.code,
            },
            field: binding.field,
        }));
    },
    setGateways(state, gateways) {
        state.gateways = gateways.map(gateway => ({
            ...gateway,
            configuration: gateway.configuration || {},
        }));
    },
    setActiveGateway(state, gateway) {
        const hasLocalFTPConfiguration = gateway && gateway.configuration && gateway.configuration.local_ftp_configuration;
        const hasURLConfiguration = gateway && gateway.configuration && gateway.configuration.url_configuration;
        const hasExternalFTPConfiguration = gateway && gateway.configuration && gateway.configuration.external_ftp_configuration;
        const hasFileConfiguration = gateway && gateway.configuration && gateway.configuration.file_configuration;

        state.activeGateway = {
            id: gateway ? gateway.id : null,
            name: gateway ? gateway.name : null,
            isUsed: gateway ? gateway.is_used : true,
            comment: gateway ? gateway.comment : null,
            configuration: {
                id: gateway ? gateway.configuration.id : null,
                isComplexGatewayConfig: gateway ? gateway.configuration.is_complex_gateway_config : false,
                fetchMethod: gateway ? gateway.configuration.fetch_method : '',
                proxyCode: gateway ? gateway.configuration.proxy_code : '',
                cronExpression: gateway ? gateway.configuration.cron_expression : '',
                metadatas: gateway ? gateway.configuration.metadatas : [],
                fileConfiguration: {
                    id: hasFileConfiguration ? gateway.configuration.file_configuration.id : null,
                    ownership: hasFileConfiguration ? gateway.configuration.file_configuration.ownership : 'INDIVIDUAL',
                    isZip: hasFileConfiguration ? gateway.configuration.file_configuration.is_zip : true,
                    zipName: hasFileConfiguration ? gateway.configuration.file_configuration.zip_name : null,
                    fileName: hasFileConfiguration ? gateway.configuration.file_configuration.file_name : null,
                    fileExtension: hasFileConfiguration ? gateway.configuration.file_configuration.file_extension : '.csv',
                    fileType: hasFileConfiguration ? gateway.configuration.file_configuration.file_type : 'CSV',
                    fileSeparator: hasFileConfiguration ? gateway.configuration.file_configuration.file_separator : undefined
                },
                mediaConfiguration: {
                    dataField: gateway?.configuration.media_configuration?.data_field,
                    downloadDelay: gateway ? gateway.configuration.media_configuration.download_delay : 0,
                    fetchMethod: gateway ? gateway.configuration.media_configuration.fetch_method : 'URL',
                    folder: gateway ? gateway.configuration.media_configuration.folder : '/',
                    id: gateway ? gateway.configuration.media_configuration.id : null,
                    ignoreExistingMediaFileName: gateway ? gateway.configuration.media_configuration.ignore_existing_media_file_name : false,
                    isIterative: gateway ? gateway.configuration.media_configuration.is_iterative : false,
                },
                globalConfiguration: {
                    id: gateway ? gateway.configuration.global_configuration.id : null,
                    encodingId: gateway ? gateway.configuration.global_configuration.encoding_id : -1,
                    maxMediaDownloadCount: gateway ? gateway.configuration.global_configuration.max_media_download_count : 5,
                    downloadBatchLength: gateway ? gateway.configuration.global_configuration.download_batch_length : 50,
                },
                localFTPConfiguration: {
                    id: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.id : null,
                    isGlobalFTPAccount: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.is_global_ftp_account : null,
                    login: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.login : null,
                    secret: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.secret : null,
                    accountId: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.account_id : null,
                    directory: hasLocalFTPConfiguration ? gateway.configuration.local_ftp_configuration.directory : null,
                },
                urlConfiguration: {
                    id: hasURLConfiguration ? gateway.configuration.url_configuration.id : null,
                    listingURL: hasURLConfiguration ? gateway.configuration.url_configuration.listing_url : null,
                    mediaURL: hasURLConfiguration ? gateway.configuration.url_configuration.media_url : null,
                    hasMediaURL: hasURLConfiguration ? gateway.configuration.url_configuration.has_media_url : false,
                },
                externalFTPConfiguration: {
                    id: hasExternalFTPConfiguration ? gateway.configuration.external_ftp_configuration.id : null,
                    url: hasExternalFTPConfiguration ? gateway.configuration.external_ftp_configuration.url : null,
                    login: hasExternalFTPConfiguration ? gateway.configuration.external_ftp_configuration.login : null,
                    secret: hasExternalFTPConfiguration ? gateway.configuration.external_ftp_configuration.secret : null,
                    doRecursiveFileSearch: hasExternalFTPConfiguration ? gateway.configuration.external_ftp_configuration.do_recursive_file_search : false,
                },
            }
        };
    },
    setMetadatas(state, metadatas) {
        state.metadatas = [{
                id: -1,
                code: '*',
                description: 'A joker can be used to completely ignore a portion of a data, it can be used to ignore the timestamp from a filename for example.',
                is_selectable: true,
            },
            ...metadatas
        ].map(metadata => {
            const label = (metadata.id === -1)
                ? 'Joker'
                : metadata.code.replace(/{|}/g, '');

            const color = (metadata.id === -1)
                ? 'gray'
                : 'secondary';

            return {
                id: metadata.id,
                code: metadata.code,
                description: metadata.description,
                isSelectable: metadata.is_selectable,
                color,
                label,
            }
        });
    },
    setEncodings(state, encodings) {
        state.encodings = [{
            id: -1,
            name: 'Automatique',
        },...encodings];
    },
}

export default GatewayMutations;
